"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUniqueId = void 0;
var react_1 = require("react");
var idCounter = 0;
function useUniqueId() {
    idCounter += 1;
    return react_1.useRef("unique-id-" + idCounter).current;
}
exports.useUniqueId = useUniqueId;
//# sourceMappingURL=useUniqueId.js.map